var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Title from '../../atoms/Title';
import Desc from '../../atoms/Desc';
import { VerticalGap } from '../../atoms/Gap/Gap';
import PhoneAuthenticationForm from '../../molecules/PhoneAuthenticationForm/PhoneAuthenticationForm';
import { getCountriesInfo, makeOptionListFromCountriesInfo } from '../../../businessLogics';
import { MainContents } from '../../../styles/_common.style';
import { useIsMobile } from '../../../businessLogics/hooks';
var FindEmailInitial = function () {
    var options = makeOptionListFromCountriesInfo(getCountriesInfo());
    var _a = useState(options.find(function (option) { return option.key === '82'; })), countryCode = _a[0], setCountryCode = _a[1];
    var _b = useState(''), phoneNumber = _b[0], setPhoneNumber = _b[1];
    var _c = useState(false), isPhoneAuthPassed = _c[0], setIsPhoneAuthPassed = _c[1];
    var isMobile = useIsMobile();
    return (_jsxs(MainContents, __assign({ paddingTop: 70 }, { children: [_jsx(Title, { children: "\uC774\uBA54\uC77C \uCC3E\uAE30" }), _jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsx(Desc, { children: "\uD734\uB300\uD3F0 \uC778\uC99D\uC744 \uC9C4\uD589\uD574 \uC8FC\uC138\uC694." }), _jsx(VerticalGap, { size: isMobile ? 20 : 40 }), _jsx(PhoneAuthenticationForm, { countryCode: countryCode, setCountryCode: setCountryCode, phoneNumber: phoneNumber, setPhoneNumber: setPhoneNumber, isAuthentic: isPhoneAuthPassed, setIsAuthentic: setIsPhoneAuthPassed })] })));
};
export default FindEmailInitial;
//# sourceMappingURL=FindEmailInitial.js.map